import { localeHe, MbscModule, setOptions } from "@mobiscroll/angular";
import { BrowserModule } from "@angular/platform-browser";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BsDropdownModule } from "node_modules/ngx-bootstrap/dropdown";
import { AlertModule } from "node_modules/ngx-bootstrap/alert";
import { UiSwitchModule } from "node_modules/ngx-ui-switch";
import { TimepickerModule } from "node_modules/ngx-bootstrap/timepicker";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SendSMSSettingsComponent } from "./Automation/send-smssettings/send-smssettings.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import "zone.js";
import { NgxMaterialTimepickerModule } from "node_modules/ngx-material-timepicker";
import { ModalModule } from "node_modules/ngx-bootstrap/modal";
import { HomeComponent } from "./home/home.component";
import { AboutComponent } from "./Automation/about/about.component";
import { NotfoundComponent } from "./Automation/notfound/notfound.component";
import { GetBalanceComponent } from "./Automation/get-balance/get-balance.component";
import { CollapseModule } from "node_modules/ngx-bootstrap/collapse";
import { MainsmsComponent } from "./Automation/mainsms/mainsms.component";
import { TabsModule } from "node_modules/ngx-bootstrap/tabs";
import { ButtonModule } from "node_modules/primeng/button";
import { CardModule } from "node_modules/primeng/card";
import { TemplatesmsComponent } from "./Automation/templatesms/templatesms.component";
import { InputSwitchModule } from "node_modules/primeng/inputswitch";
import { TabViewModule } from "node_modules/primeng/tabview";
import { CheckboxModule } from "node_modules/primeng/checkbox";
import { TooltipModule } from "node_modules/ngx-bootstrap/tooltip";
import { SidebarModule } from "node_modules/primeng/sidebar";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MultiSelectModule } from "node_modules/primeng/multiselect";
import { NgSelectModule } from "@ng-select/ng-select";
import { ReportssmsComponent } from "./Automation/reportssms/reportssms.component";
import { BsDatepickerModule, BsLocaleService } from "ngx-bootstrap/datepicker";
import { defineLocale } from "ngx-bootstrap/chronos";
import { heLocale } from "ngx-bootstrap/locale";
import { TableModule } from "primeng/table";
import { ChildreportComponent } from "./Automation/childreport/childreport.component";
import { InputMaskModule } from "primeng/inputmask";
import { environment } from "src/environments/environment";
import { LoggerModule, NgxLoggerLevel } from "ngx-logger";
import { ChildadminpanelComponent } from "./Automation/childadminpanel/childadminpanel.component";
import { ChildeditorComponent } from "./Automation/childeditor/childeditor.component";
import { NgxEmojiPickerModule } from "ngx-emoji-picker";
import { PasswordModule } from "primeng/password";
import { DataViewModule } from "primeng/dataview";
import { DropdownModule } from "primeng/dropdown";
import { VirtualScrollerModule } from "primeng/virtualscroller";
import { PanelModule } from "primeng/panel";
import { MenubarModule } from "primeng/menubar";
import { ClarityModule } from "@clr/angular";
import { MessagesModule } from "primeng/messages";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { CarouselModule } from "primeng/carousel";
import { DynamicDialogModule } from "primeng/dynamicdialog";
import { DialogModule } from "primeng/dialog";
import { PaginatorModule } from "primeng/paginator";
import { ArchwizardModule } from "angular-archwizard";

import { CommonModule } from "@angular/common";
import { MenuModule } from "primeng/menu";
import { ChipsModule } from "primeng/chips";
import { FileUploadModule } from "primeng/fileupload";
// Loader
import { ProgressSpinnerModule } from "primeng/progressspinner";

import { TokenInterceptor } from "./services/interceptor/http.interceptor";
import { ClientbaseComponent } from "./Customers/clientbase/clientbase.component";
import { TopbarComponent } from "./topbar/topbar.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { HostListenerBeforeUnloadDirective } from "./services/Common/host-listener-before-unload.directive";
import { CustcardEditpersonalComponent } from "./Customers/custcard-editpersonal/custcard-editpersonal.component";
import { DynamiceditScreenComponent } from "./Customers/dynamicedit-screen/dynamicedit-screen.component";
import { DialogService, DynamicDialogRef, MessageService } from "primeng/api";
import { HttpServiceAccount } from "./services/Authorization/http/http.service_Account";
import { CustcardComponent } from "./Customers/custcard/custcard.component";
import { Custcardview1Component } from "./Customers/custcardview1/custcardview1.component";
import { Custcardview2Component } from "./Customers/custcardview2/custcardview2.component";
import { Custcardview42Component } from "./Customers/custcardview42/custcardview42.component";
import { Custcardview44Component } from "./Customers/custcardview44/custcardview44.component";
import { Custcardview43Component } from "./Customers/custcardview43/custcardview43.component";
import { Custcardview57Component } from "./Customers/custcardview57/custcardview57.component";
import { Custcardview4Component } from "./Customers/custcardview4/custcardview4.component";
import { Custcardview45Component } from "./Customers/custcardview45/custcardview45.component";
import { Custcardview5Component } from "./Customers/custcardview5/custcardview5.component";
import { Custcardview46Component } from "./Customers/custcardview46/custcardview46.component";
import { CalendarviewComponent } from "./Diary/calendarview/calendarview.component";
import { CalendarbaseComponent } from "./Diary/calendarbase/calendarbase.component";
import { CreateAppointmentComponent } from "./Diary/create-appointment/create-appointment.component";
import { CreateAppCustomerComponent } from "./Diary/create-app-customer/create-app-customer.component";
import { CreateAppServiceComponent } from "./Diary/create-app-service/create-app-service.component";
import { CreateAppSummaryComponent } from "./Diary/create-app-summary/create-app-summary.component";
import { CreateAppAbsenceComponent } from "./Diary/create-app-absence/create-app-absence.component";
import { CanDeactivateComponent } from "./can-deactivate/can-deactivate.component";
import { DateMaskDirective } from "./services/Common/date-mask.directive";
import { LongPressDirective } from "./long-press.directive";
// import { CustomReuseStrategy } from './CustomReuseStrategy';
// import { RouteReuseStrategy } from "@angular/router";

@NgModule({
    declarations: [AppComponent, SendSMSSettingsComponent, HomeComponent, AboutComponent, NotfoundComponent, GetBalanceComponent, MainsmsComponent, TemplatesmsComponent, ReportssmsComponent, ChildreportComponent, ChildadminpanelComponent, ChildeditorComponent, ClientbaseComponent, TopbarComponent, SidebarComponent, HostListenerBeforeUnloadDirective, CustcardEditpersonalComponent, DynamiceditScreenComponent, CustcardComponent, Custcardview1Component, Custcardview2Component, Custcardview42Component, Custcardview44Component, Custcardview43Component, Custcardview57Component, Custcardview4Component, Custcardview45Component, Custcardview5Component, Custcardview46Component, CalendarviewComponent, CalendarbaseComponent, CreateAppointmentComponent, CreateAppCustomerComponent, CreateAppServiceComponent, CreateAppSummaryComponent, CreateAppAbsenceComponent, CanDeactivateComponent, DateMaskDirective, LongPressDirective],
    entryComponents: [DynamiceditScreenComponent, ChildadminpanelComponent, ChildeditorComponent, ChildreportComponent, CanDeactivateComponent],
    imports: [
        MbscModule,
        BrowserModule,
        // SidebarModule.forRoot(),
        CommonModule,
        HttpClientModule,
        AppRoutingModule,
        BsDropdownModule.forRoot(),
        AlertModule.forRoot(),
        UiSwitchModule.forRoot({
            size: "medium",
            color: "rgb(0, 189, 99)",
            switchColor: "#80FFA2",
            defaultBgColor: "#00ACFF",
            defaultBoColor: "#476EFF",
            checkedLabel: "כן",
            uncheckedLabel: "לא",
        }),
        TimepickerModule.forRoot(),
        BrowserAnimationsModule,
        NgxMaterialTimepickerModule,
        ModalModule.forRoot(),
        CollapseModule.forRoot(),
        TabsModule.forRoot(),
        CardModule,
        ButtonModule,
        InputSwitchModule,
        TabViewModule,
        CheckboxModule,
        TooltipModule.forRoot(),
        SidebarModule,
        FormsModule,
        ReactiveFormsModule,
        MultiSelectModule,
        NgSelectModule,
        BsDatepickerModule.forRoot(),
        TableModule,
        InputMaskModule,
        LoggerModule.forRoot({
            serverLoggingUrl: `${environment.urlserv}/Home/logs`,
            level: NgxLoggerLevel.TRACE,
            serverLogLevel: NgxLoggerLevel.INFO,
            disableConsoleLogging: true,
        }),
        NgxEmojiPickerModule.forRoot(),
        PasswordModule,
        MenubarModule,
        PanelModule,
        ClarityModule,
        MessagesModule,
        OverlayPanelModule,
        ScrollPanelModule,
        DialogModule,
        ChipsModule,
        FileUploadModule,
        CarouselModule,
        ArchwizardModule,

        //Loader
        ProgressSpinnerModule,
        DataViewModule,
        DropdownModule,
        VirtualScrollerModule,
        PanelModule,
        MenuModule,
        DynamicDialogModule,
        ReactiveFormsModule,
        PaginatorModule,
    ],
    providers: [
        DialogService,
        DynamicDialogRef,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },

        // {
        //     provide: RouteReuseStrategy,
        //     useClass: CustomReuseStrategy
        // },

        HttpServiceAccount,
        MessageService,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
    constructor(private bsLocaleService: BsLocaleService) {
        this.bsLocaleService.use("he");
    }
}

setOptions({
    locale: localeHe,
    theme: "windows",
    themeVariant: "light",
});

defineLocale("he", heLocale);
